/**
 * Testimonial Carousel widget.
 */
class TestimonialCarousel {
	widget;
	buttonPrev;
	buttonNext;
	carousel;
	carouselItems;
	observer;

	/**
	 * Instantiate class for each widget.
	 *
	 * @param {HTMLElement} widget
	 */
	constructor( widget ) {
		this.widget = widget;
		this.buttonPrev = this.widget.querySelector( '.nav-button--prev' );
		this.buttonNext = this.widget.querySelector( '.nav-button--next' );
		this.carousel = this.widget.querySelector( '.carousel' );
		this.carouselItems = this.carousel.querySelectorAll( '.carousel-item' );
		
		// Reset widget state on load
		this.carousel.scrollLeft = 0;
		
		// Register events
		this.buttonPrev.addEventListener( 'click', event => this.buttonClickHandler( event, -1 ) );
		this.buttonNext.addEventListener( 'click', event => this.buttonClickHandler( event, 1 ) );
		this.registerIntersectionObserver();
	}

	/**
	 * Handle navigation button click.
	 * 
	 * @param {Event} event
	 * @param {Int} direction
	 */
	buttonClickHandler( event, direction ) {
		event.preventDefault();
		
		const slideIndex = this.getCurrentSlideIndex() + direction;
		const slide = this.widget.querySelector( '.carousel-item[data-slide-index="' + slideIndex + '"]' );

		if( slide ) {
			// Go to slide
			slide.scrollIntoView( {
				container: 'nearest',
				block: 'nearest',
				inline: 'center'
			} );

			// Set focus
			slide.focus();
		}
	}

	/**
	 * Register intersection observer for updating slider position when the user navigates between slides.
	 */
	registerIntersectionObserver() {
		this.observer = new IntersectionObserver( entries => this.onSlideChange( entries ), {
			root: this.carousel,
			threshold: 1,
		} );

		this.carouselItems.forEach( testimonial => {
			this.observer.observe( testimonial );
		} );
	}

	/**
	 * Intersection observer callback - update current slide index and set button states.
	 * 
	 * @param {IntersectionObserverEntry[]} entries
	 */
	onSlideChange( entries ) {
		entries.forEach( entry => {
			if( entry.isIntersecting ) {
				const slideIndex = Number( entry.target.dataset.slideIndex );
				
				// Update slide index
				this.widget.dataset.currentSlideIndex = slideIndex;

				// Set button states
				this.buttonPrev.disabled = 0 === slideIndex;
				this.buttonNext.disabled = this.getSlideCount() - 1 === slideIndex;
			}
		} );
	}

	/**
	 * Get current slide index.
	 *
	 * @returns {Number}
	 */
	getCurrentSlideIndex() {
		return parseInt( this.widget.dataset.currentSlideIndex );
	}

	/**
	 * Get total slide count.
	 *
	 * @returns {Number}
	 */
	getSlideCount() {
		return parseInt( this.widget.dataset.slideCount );
	}
}

document.querySelectorAll( '.whippet-testimonial-carousel' ).forEach( widget => {
	new TestimonialCarousel( widget );
} );
